<template>
  <div id="surveyCreatorContainer"></div>
</template>

<script>
import { SurveyCreator } from "survey-creator-knockout"
import { editorLocalization } from 'survey-creator-core'
editorLocalization.currentLocale = 'fr'
import "survey-creator-core/survey-creator-core.i18n"
import "survey-creator-core/i18n/french"
import "survey-core/defaultV2.min.css"
import "survey-creator-core/survey-creator-core.min.css"
import Form from "./entity.js"

const creatorOptions = {
  showLogicTab: true,
  isAutoSave: false,
  showState: true,
  showPreviewTab: true,
  haveCommercialLicense: true,
  showDefaultLanguageInTestSurveyTab: true, // pour avoir la preview
  showSimulatorInTestSurveyTab: true,
}
export default {
  name: 'hippolyte.conciliator.form.creator',
  props: {
    id: String,
    f: Object,
    test: Boolean
  },
  data() {
    return {
      form: this.f || {}
    }
  },
  mounted() {
    const creator = new SurveyCreator(creatorOptions)
    if (this.test) creator.activeTab = 'test'
    if (this.id && Object.keys(this.form).length === 0) {
      this.form = new Form({ id: this.id }, this.$socket)
      this.form.get().then(form => {
        creator.JSON = form.content
      })
    } else if (this.form) {
      creator.JSON = this.form.content
    }


    creator.saveSurveyFunc = (saveNo, callback) => {
      this.saveSurvey(saveNo, creator.JSON, callback)
    }

    creator.render('surveyCreatorContainer')
  },
  methods: {
    async saveSurvey(saveNo, data, callback) {
      const form = new Form(
        Object.assign(this.form, {
          title: data.title,
          content: data,
          status: 'draft',
          scope: this.form.scope || 'application'
        }), this.$socket)

      try {
        await form.save()
        callback(saveNo, true)
      } catch (error) {
        console.log('save error', error)
        callback(saveNo, false)
      }
    }
  }
}
 </script>

<style lang="stylus" scoped>
#surveyCreatorContainer
  height 100vh
  width 97vw
</style>